module.exports = __webpack_public_path__ + "media/images/edion/top/3-8e06df2d00f7351e777a900eff3b9d96.png";